import { useTranslation } from 'react-i18next';
import WithTooltip from '../Fundamentals/Tooltip/WithTooltip';
import { withSek } from './worksheetFormatters';

interface ExcludedTieredPlansNoteProps {
    grossRevenue: number;
}

const ExcludedTieredPlansNote = ({ grossRevenue }: ExcludedTieredPlansNoteProps) => {
    const { t } = useTranslation();

    return (
        <WithTooltip content={t('priceSimulation.excludesTieredPlansTooltip')} className="align-self-start" focusable>
            <span className="body-xs text-secondary">
                {grossRevenue !== 0 ? t('priceSimulation.excludesTieredPlans', { amount: withSek(grossRevenue) }) : t('priceSimulation.excludesTieredPlansNoRevenue')}
            </span>
        </WithTooltip>
    );
};

export default ExcludedTieredPlansNote;
